<template>
  <div>
    <b-list-group-item variant="primary" class="font-weight-bold"
      >What project is {{firstName}} coming to</b-list-group-item
    >
    <div v-if="aliasList != null">
      <b-button
        class="mt-2"
        block
        variant="outline-info"
        v-for="(item, key) in aliasList"
        :key="key"
        @click="addAttendence(item.id)"
      >
        {{ item.aliasName }}
      </b-button>
      <b-button
        class="mt-2"
        block
        variant="success"
        :to="{
          name: navBack,
          params: personData,
        }"
        >Back</b-button
      >
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    personData() {
      return this.$route.params;
    },
    navBack(){
      if(this.personData.navBack != null){
        return this.personData.navBack
      }return 'person-picker'
    },
    ...mapGetters(["urlPrefix"]),
  },
  mounted() {
    this.firstName = this.personData.firstName;
    this.lastName = this.personData.lastName;
    this.personId = this.personData.pk;
    this.month = this.personData.month;
    this.monthNum = this.personData.monthNum;
    this.getData();
  },
  methods: {
    getData() {
      this.$store
        .dispatch("genericGetApiCall", {
          mutationName: null,
          url: this.$store.getters.urlPrefix + "api/projectAliasesLive/",
        })
        .then((resolve) => {
          this.aliasList = resolve.results;
        });
      // if we want to structure this data by last attended session / most popular session do it here
    },
    addAttendence(id) {
      //alert("add the attendence" + id +  ' for person id '+ this.personData.pk);
      // So actions here ... Post to the attendance table the attendance
      // Structure the mutation following a sucessfull post to add to the todays atendees list
      // Build Payload
      // Return to sign in home

      // Build Payload
      const isoDateTime = new Date().toISOString();
      const isoDate = isoDateTime.slice(0, 10);
      const isoTime = isoDateTime.slice(11, 19);
      const mutationName = "addToPeopleAttending";
      const url = this.urlPrefix + "api/attendance/";
      const data = {
        dateIn: isoDate,
        timeIn: isoTime,
        person: this.personData.pk,
        projectAliases: id,
      };
      const payload = {
        mutationName: mutationName,
        url: url,
        data: data,
      };
      // Post data
      this.$store
        .dispatch("genericPostApiCall", payload)
        // Once complete return to the calling component modularity added late in dat so some call this without route param
        .then(() => {
          if (this.personData.navTo == null) {
            this.$router.push({ name: "signin" });
          } else {
            this.$router.push({ name: this.personData.navTo });
          }
        });
    },
  },
  data() {
    return {
      aliasList: null,
      personId: null,
      firstName: null,
      lastName: null,
      month: null,
      monthNum: null,
    };
  },
};
</script>

<style scoped></style>
